export default {
  setupArcade() {
    const arcade = document.querySelector(".site-footer--arcade");
    if (!arcade) {
      return;
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          document.body.classList.add("arcade-in-view");
        } else {
          document.body.classList.remove("arcade-in-view");
        }
      });
    });

    this.observer.observe(arcade);
  },

  init() {
    let lastScroll = 0;
    const stickyBar = document.querySelector(".sticky-cta");

    this.setupArcade();

    window.addEventListener("scroll", () => {
      const currentScroll = window.scrollY;

      if (window.scrollY > 100) {
        document.body.classList.add("show-sticky-cta");
      } else {
        document.body.classList.remove("show-sticky-cta");
      }
    });
  },
  destroy() {
    this.observer.disconnect();
  },
};
